import { render, staticRenderFns } from "./iframeWeb.vue?vue&type=template&id=965450e8&scoped=true"
import script from "./iframeWeb.vue?vue&type=script&lang=js"
export * from "./iframeWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965450e8",
  null
  
)

export default component.exports